export default __webpack_public_path__ + "static/media/send-Application.b4f2d21e.svg";